import { render, staticRenderFns } from "./190.vue?vue&type=template&id=8e1b2e2e&scoped=true&"
var script = {}
import style0 from "./190.vue?vue&type=style&index=0&id=8e1b2e2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1b2e2e",
  null
  
)

export default component.exports